import React from 'react';
import { Stack, TextField } from '@mui/material';
import AdapterJalali from '@date-io/date-fns-jalali';

import {
  MobileDatePicker,
  LocalizationProvider,
} from '@mui/x-date-pickers-pro';
import { SubstractMonth } from 'utils/SubstractMonth';
import { DateSelectorFunction } from './Functions/DateSelectorFunction';
import useSetFromDateUI from './Hooks/useSetFromDateUI';
import useCheckSetTodayOnMount from './Hooks/useCheckSetTodayOnMount';
import RightAlignedTextField from 'Global/Components/CommonComponents/RightAlignedTextField/RightAlignedTextField';
import useSetInitialDateForEdit from './Hooks/useSetInitialDateForEdit';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import jalaali from 'jalaali-js';
import ErrorSupportForAllMui from 'Global/Components/CommonComponents/ErrorSupportForAllMui/ErrorSupportForAllMui';

const EditableMuiDatePicker = ({
  Placeholder,
  SetOutput,
  Disabled,
  IsRange,
  IsFromDate,
  onChange,
  isEnglish = true,
  disableInit,
  initialValue,
  disableToday = true,
  fullWidth = false,
  name,
  errors,
}) => {
  const jalaliDate =
    initialValue && initialValue.split('/');
  const gregorianDate =
    jalaliDate &&
    jalaali.toGregorian(
      parseInt(jalaliDate[0]),
      parseInt(jalaliDate[1]),
      parseInt(jalaliDate[2])
    );
  const date = gregorianDate
    ? new Date(
        gregorianDate.gy,
        gregorianDate.gm - 1,
        gregorianDate.gd
      )
    : null;

  const [value, setValue] = React.useState(
    initialValue
      ? date
      : IsRange && IsFromDate
      ? SubstractMonth()
      : new Date()
  );
  useSetInitialDateForEdit(initialValue, setValue);
  useCheckSetTodayOnMount(
    value,
    disableInit,
    onChange,
    disableToday
  );
  useSetFromDateUI(IsRange, IsFromDate, SetOutput);

  const done_msg = FindLangKey(
    'general-public-label-approve'
  );
  const cancel_msg = FindLangKey(
    'general-public-label-dismiss'
  );

  return (
    <LocalizationProvider
      dateAdapter={AdapterJalali}
      localeText={{
        okButtonLabel: done_msg,
        cancelButtonLabel: cancel_msg,
      }}
    >
      <div
        dir={isEnglish ? 'ltr' : 'rtl'}
        style={{
          width: fullWidth ? '100%' : '',
        }}
      >
        <MobileDatePicker
          disabled={Disabled ?? false}
          label={Placeholder}
          value={value}
          onChange={(Date) => {
            DateSelectorFunction(
              setValue,
              Date,
              IsRange,
              IsFromDate,
              SetOutput
            );
          }}
          renderInput={(params) =>
            !isEnglish ? (
              <RightAlignedTextField
                color="colorPrimer"
                {...params}
                fullWidth
                InputProps={{
                  style: {
                    height: '40px',
                  },
                }}
              />
            ) : (
              <TextField
                color="colorPrimer"
                {...params}
                fullWidth
                InputProps={{
                  style: {
                    height: '40px',
                  },
                }}
              />
            )
          }
        />
        <Stack>
          {errors && !!errors[name] && (
            <ErrorSupportForAllMui label={Placeholder} />
          )}
        </Stack>
      </div>
    </LocalizationProvider>
  );
};

export default EditableMuiDatePicker;
